import { get } from '@apps/firsthomecoach/src/api/utils';

export const getGuidance = ({ slug, isExternal }) => get(`/guidances/${slug}?isExternal=${isExternal}`);
export const getGuidanceList = () => get(`/guidances`);

export const guidance = { getGuidance, getGuidanceList };
